export default {
    TRADITIONAL_PATH: '',
    ROBO_PATH: 'inversion-automatizada',
    CREDIT_CARD_PATH: 'tarjeta-credito-sin-cuenta',
    VANITY_FAIR_CARD_PATH: 'tarjeta-club-lectura-vanity-fair',
    EL_HORMIGUERO_CARD_PATH: 'tarjeta-el-hormiguero',
    CREDIT_CARD_LIGHT_PATH: 'tarjeta-credito-sin-cuenta-openbank',
    VANITY_FAIR_CARD_LIGHT_PATH: 'tarjeta-club-lectura-vanity-fair-openbank',
    EL_HORMIGUERO_CARD_LIGHT_PATH: 'tarjeta-el-hormiguero-openbank',
    GBI_PATH: 'inversion-por-objetivos',
    LOAN_PATH: 'prestamo-sin-cuenta',
    MB_CREDIT_CARDS_PATH: 'myprofile/cards',
};
